import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { debounceTime, of, switchMap } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MoveDeviceService } from '~move-device/services/move-device.service';
import { MoveDeviceActions } from '~move-device/store/move-device.actions';
import { processRestError } from '~shared/error-helper';

export const loadCustomersEffect = createEffect(
    (actions$: Actions = inject(Actions), moveDeviceService = inject(MoveDeviceService)) => {
        return actions$.pipe(
            ofType(MoveDeviceActions.loadCustomers),
            switchMap(() =>
                moveDeviceService.getCustomers().pipe(
                    map((customers) => MoveDeviceActions.loadCustomersSuccess({ customers })),
                    catchError((err) => of(MoveDeviceActions.loadCustomersFailure({ error: processRestError(err) })))
                )
            )
        );
    },
    { functional: true }
);

export const moveDeviceEffect = createEffect(
    (actions$: Actions = inject(Actions), moveDeviceService = inject(MoveDeviceService)) => {
        return actions$.pipe(
            ofType(MoveDeviceActions.moveDevice),
            switchMap(({ deviceId, customerId, withoutVehicle, keepVehicle, deprecate }) =>
                moveDeviceService.MoveDevice({ deviceId, customerId, withoutVehicle, keepVehicle, deprecate }).pipe(
                    map(() => MoveDeviceActions.moveDeviceSuccess()),
                    catchError((err) => of(MoveDeviceActions.moveDeviceFailure({ error: processRestError(err) })))
                )
            )
        );
    },
    { functional: true }
);

export const moveDeviceSuccessEffect = createEffect(
    (actions$: Actions = inject(Actions), router = inject(Router)) => {
        return actions$.pipe(
            ofType(MoveDeviceActions.moveDeviceSuccess),
            debounceTime(300),
            tap(() => router.navigate(['/status']).then((): void => {}))
        );
    },
    { functional: true, dispatch: false }
);
